// extracted by mini-css-extract-plugin
export var lg = "_e6-7";
export var md = "_e6-6";
export var placeholderContainer = "_e6-1";
export var placeholderIcon = "_e6-2";
export var productImage = "_e6-0";
export var sm = "_e6-5";
export var xl = "_e6-8";
export var xs = "_e6-4";
export var xxs = "_e6-3";